import { render } from "./IndexConge.vue?vue&type=template&id=0c54eedc"
import script from "./IndexConge.vue?vue&type=script&lang=js"
export * from "./IndexConge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__